export default __webpack_public_path__ + "static/media/landing.d1bf9aed.svg";